/** Normalize stored value for TipTap: empty → empty doc, legacy plain text → escaped paragraph(s). */
export function normalizeEditorHtmlForTipTap(raw) {
  if (raw == null || String(raw).trim() === "") return "<p></p>";
  const s = String(raw).trim();
  if (!s.includes("<")) {
    const escaped = s
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    return `<p>${escaped.replace(/\n/g, "<br>")}</p>`;
  }
  return s;
}

/** Strip tags for PDF / plain DataField display (no DOM). */
export function stripHtmlToPlainText(html) {
  if (html == null) return "";
  const s = String(html).trim();
  if (!s || !s.includes("<")) return s;
  return s
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<\/li>/gi, "\n")
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}
